import React from 'react';
import { useTranslation } from 'react-i18next';
import ImagePreview from './ImagePreview';
import { asset } from './UI';

export default function PosterFeature({ variant }) {
  const { t } = useTranslation();
  const event = variant === 'event';
  const key = event ? 'eventPoster' : 'cataloguePoster';

  return (
    <section className="poster-feature" aria-labelledby={`${key}-title`}>
      <ImagePreview
        className="poster-feature-image"
        src={asset(event ? 'rte_nak_taraso.png' : 'katalog_naktaraso.png')}
        alt={t(`${key}.imageAlt`)}
      >
        <span className="poster-feature-caption">{t(`${key}.open`)} <span aria-hidden="true">⤢</span></span>
      </ImagePreview>
      <div className="poster-feature-copy">
        <span className="eyebrow">{t(`${key}.eyebrow`)}</span>
        <h2 id={`${key}-title`}>{t(`${key}.title`)}</h2>
        {event && (
          <dl className="event-details">
            <div><dt>{t('eventPoster.dateLabel')}</dt><dd><time dateTime="2026-09-24">{t('eventPoster.date')}</time></dd></div>
            <div><dt>{t('eventPoster.locationLabel')}</dt><dd>ICE BSD City, Tangerang</dd></div>
          </dl>
        )}
        <p>{t(`${key}.description`)}</p>
        <p className="poster-reading-note">{t('posterHint')}</p>
      </div>
    </section>
  );
}
